import { useCallback, useState } from "react";

export const useHandleSettingTag = () => {
	const [canShowSettingTag, setCanShowSettingTag] = useState(false);
	/**
	 * タグ設定画面の表示制御の変更
	 */
	const onChangeCanShowSettingTag = useCallback((value: boolean) => setCanShowSettingTag(value), []);

	return {
		canShowSettingTag,
		onChangeCanShowSettingTag,
	};
};
